import React from 'react';
import {sprintf} from 'sprintf-js';
import PropTypes from "prop-types";
import Modal from "react-bootstrap/Modal";

export default class CandidateDocuments extends React.Component{

    static propTypes = {
        language: PropTypes.string.isRequired,
        customerName : PropTypes.string.isRequired,
        setUploadQueu: PropTypes.func
    };

    maxLength = 20;
    maxSizeMb = 10;
    maxSize = this.maxSizeMb * 1024 * 1024;

    constructor(props){
        super(props);
        this.state = {
            files: [],
            showModal: false
        };
    }

    uploadCandidateFile = (event) => {
        let {files} = this.state;
        let file = event.target.files[0];

		if (!file) {
			return;
		}

        if (files.length >= this.maxLength) {
            return;
        }

        if (file.size > this.maxSize) {
            this.setState({
                showModal: true,
                modalTitle: window.Translator.getSlug('Error', this.props.language),
                modalBody: sprintf(window.Translator.getSlug('MaxFileSize%sMbExceeded', this.props.language), this.maxSizeMb)
            });
            return;
        }
        files.unshift(file);
		this.props.setUploadQueu(files);
        this.setState({files:files});
    };

    renderUploadedFiles = () => {
        return this.state['files'].map((file, index) => {
            return (
                <li key={file.name+index} className={' padding-bottom-10'}>
                    <label style={{'color': '#6f7484'}}>{file.name}</label>
                    <i className={'fa del-button cursor-pointer fa-times'}
                       onClick={() => this.deleteFile(index)} style={{'color': '#aaa'}}
                    />
                </li>
            );
        });
    };

    deleteFile(index){
        let {files} = this.state;
        files.splice(index, 1);
        this.props.setUploadQueu(files);
        this.setState({files:files});
    }

    closeModal = () => {
        this.setState({showModal: false});
    };

    render() {
        return (
            <>
                <Modal show={this.state['showModal']} onHide={this.closeModal} animation={false}
                       dialogClassName={'smallDialog'}>
                    <Modal.Header closeButton>
                        <Modal.Title>{this.state['modalTitle']}</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>{this.state['modalBody']}</Modal.Body>
                    <Modal.Footer>
                        <button onClick={this.closeModal}
                                className={'btn btn-default'}>
                            {window.Translator.getSlug('Close', this.props.language)}
                        </button>
                    </Modal.Footer>
                </Modal>
                <div className="job-post-form">
                    <div className="row">
                        <h4 className={'col-12 margin-bottom-15'}>{window.Translator.getSlug('UploadFile', this.props.language)}</h4>
                        <div className={'col-12'}>
                            {this.state['files'].length >= this.maxLength ?
                                (
                                    <label className={"col-12 padding-15 padding-right-20 " }>{sprintf(window.Translator.getSlug('MaxFileCount%sReached', this.props.language), this.maxLength)}</label>
                                )
                                : (
                                    <>
                                        <input
                                            type="file"
                                            name="file"
                                            id="file"
                                            className="inputfile agency-upload-button"
                                            onChange={this.uploadCandidateFile}
                                        />
                                        <label htmlFor="file" className={'padding-15 padding-right-20'}>
                                            <i className={'fa fa-cloud-upload-alt margin-right-10 padding-top-20 padding-bottom-20 padding-left-20'}/>
                                            {window.Translator.getSlug('UploadPHotoOrMotivationList', this.props.language)}
                                        </label>
                                    </>
                                )
                            }
                        </div>
                    </div>
                    <div className={'row'}>
                        <div className="col-12">
                            <ul className={'no-list-style padding-left-0'}>
                                {this.renderUploadedFiles()}
                            </ul>
                        </div>
                    </div>
                </div>
            </>
        );
    }
}
